/**
 * @generated SignedSource<<3814faf60b6a9c807ad74f499fa2a062>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunNovaAgentProductionInput = {
  id: string;
  taskId: string;
  message?: string | null;
  threadId?: string | null;
  runId?: string | null;
  surface?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RunNovaAgentProductionMutation$variables = {
  input: RunNovaAgentProductionInput;
};
export type RunNovaAgentProductionMutation$data = {
  readonly runNovaAgentProduction: {
    readonly result: {
      readonly run: {
        readonly id: string;
        readonly runId: string | null;
        readonly threadId: string | null;
        readonly agentId: string | null;
        readonly versionNumber: number | null;
        readonly status: string | null;
        readonly outcome: string | null;
        readonly answer: string | null;
        readonly userMessageText: string | null;
        readonly actingPerson: {
          readonly fullName: string | null;
          readonly profilePictureId: string | null;
        } | null;
        readonly ranAt: string | null;
        readonly failureState: string | null;
        readonly grounding: {
          readonly resolved: ReadonlyArray<{
            readonly token: string | null;
            readonly scope: string | null;
          }> | null;
        } | null;
      } | null;
    } | null;
    readonly task: {
      readonly id: string;
      readonly hasNovaConversation: boolean;
      readonly novaRunningRunId: string | null;
      readonly novaThread: ReadonlyArray<{
        readonly id: string;
        readonly runId: string | null;
        readonly threadId: string | null;
        readonly agentId: string | null;
        readonly versionNumber: number | null;
        readonly status: string | null;
        readonly outcome: string | null;
        readonly answer: string | null;
        readonly userMessageText: string | null;
        readonly actingPerson: {
          readonly fullName: string | null;
          readonly profilePictureId: string | null;
        } | null;
        readonly ranAt: string | null;
        readonly failureState: string | null;
        readonly grounding: {
          readonly resolved: ReadonlyArray<{
            readonly token: string | null;
            readonly scope: string | null;
          }> | null;
          readonly skipped: ReadonlyArray<{
            readonly token: string | null;
          }> | null;
        } | null;
      }>;
    } | null;
  } | null;
};
export type RunNovaAgentProductionMutation = {
  variables: RunNovaAgentProductionMutation$variables;
  response: RunNovaAgentProductionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "runId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNumber",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outcome",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answer",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userMessageText",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "NovaRunAuthor",
  "kind": "LinkedField",
  "name": "actingPerson",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ranAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failureState",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "NovaGroundingResolvedEntry",
  "kind": "LinkedField",
  "name": "resolved",
  "plural": true,
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scope",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RunNovaAgentProductionPayload",
    "kind": "LinkedField",
    "name": "runNovaAgentProduction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaRunResult",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgentRun",
            "kind": "LinkedField",
            "name": "run",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaGroundingAccount",
                "kind": "LinkedField",
                "name": "grounding",
                "plural": false,
                "selections": [
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNovaConversation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "novaRunningRunId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgentRun",
            "kind": "LinkedField",
            "name": "novaThread",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaGroundingAccount",
                "kind": "LinkedField",
                "name": "grounding",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NovaGroundingReferenceEntry",
                    "kind": "LinkedField",
                    "name": "skipped",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RunNovaAgentProductionMutation",
    "selections": (v15/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RunNovaAgentProductionMutation",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "b98b5c8e95b45aad143c2dfd42ee713f",
    "id": null,
    "metadata": {},
    "name": "RunNovaAgentProductionMutation",
    "operationKind": "mutation",
    "text": "mutation RunNovaAgentProductionMutation(\n  $input: RunNovaAgentProductionInput!\n) {\n  runNovaAgentProduction(input: $input) {\n    result {\n      run {\n        id\n        runId\n        threadId\n        agentId\n        versionNumber\n        status\n        outcome\n        answer\n        userMessageText\n        actingPerson {\n          fullName\n          profilePictureId\n        }\n        ranAt\n        failureState\n        grounding {\n          resolved {\n            token\n            scope\n          }\n        }\n      }\n    }\n    task {\n      id\n      hasNovaConversation\n      novaRunningRunId\n      novaThread {\n        id\n        runId\n        threadId\n        agentId\n        versionNumber\n        status\n        outcome\n        answer\n        userMessageText\n        actingPerson {\n          fullName\n          profilePictureId\n        }\n        ranAt\n        failureState\n        grounding {\n          resolved {\n            token\n            scope\n          }\n          skipped {\n            token\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f34eb593b5815232638ed2fcbf15ade";

export default node;
